import React from "react"
import { useLocation } from "react-router-dom"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { usePreVisitTracking } from "./hooks/usePreVisitTracking"
import type { IntakeFormsData } from "./hooks/useIntakeForms"

export function PreVisitIntakeTracking({ program }: { program: IntakeFormsData["program"] }): null {
  const { search } = useLocation()
  const { track } = usePreVisitTracking()
  const viewed = React.useRef(false)

  React.useEffect(() => {
    if (viewed.current) return
    viewed.current = true
    const source = new URLSearchParams(search).get("source")
    const entrySource =
      source === "booking_flow" || source === "in_app" || source === "appointments_page" || source === "email"
        ? source
        : "unknown"
    track(MemberActions.PREPARE_FOR_VISIT_VIEWED, { entrySource, ...(program ? { program } : {}) })
  }, [search, track, program])

  return null
}
